import { render, staticRenderFns } from "./google-search-settings.vue?vue&type=template&id=71255a93&scoped=true"
import script from "./google-search-settings.vue?vue&type=script&lang=js"
export * from "./google-search-settings.vue?vue&type=script&lang=js"
import style0 from "./google-search-settings.vue?vue&type=style&index=0&id=71255a93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71255a93",
  null
  
)

export default component.exports